import React from 'react';
import {View, StyleSheet, TouchableOpacity, StatusBar} from 'react-native';
import {Text} from 'react-native-paper';
import LinearGradient from 'react-native-linear-gradient';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {colors, spacing} from '../../theme';

const GradientHeader = ({
  title,
  subtitle,
  onBack,
  onMenu,
  children,
}) => {
  const insets = useSafeAreaInsets();

  return (
    <>
      <StatusBar barStyle="dark-content" backgroundColor={colors.primaryPastel} />
      <View style={{height: insets.top, backgroundColor: colors.primaryPastel}} />
      <LinearGradient
        colors={[colors.primaryPastel, colors.surface]}
        locations={[0, 1]}
        style={styles.gradient}>
        <View style={styles.row}>
          {onBack && (
            <TouchableOpacity onPress={onBack} style={styles.btn}>
              <Icon name="arrow-left" size={24} color={colors.primary} />
            </TouchableOpacity>
          )}
          {onMenu && (
            <TouchableOpacity onPress={onMenu} style={styles.btn}>
              <Icon name="menu" size={24} color={colors.primary} />
            </TouchableOpacity>
          )}
          <View style={styles.titleContainer}>
            <Text style={styles.title} numberOfLines={1}>{title}</Text>
            {subtitle ? <Text style={styles.subtitle} numberOfLines={1}>{subtitle}</Text> : null}
          </View>
          {children}
        </View>
      </LinearGradient>
    </>
  );
};

const styles = StyleSheet.create({
  gradient: {
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 3,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.xs,
    height: 56,
  },
  btn: {
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleContainer: {
    flex: 1,
    marginLeft: spacing.xs,
  },
  title: {
    color: colors.primary,
    fontSize: 18,
    fontWeight: '600',
  },
  subtitle: {
    color: colors.textSecondary,
    fontSize: 13,
    marginTop: 1,
  },
});

export default GradientHeader;
